module.exports = __webpack_public_path__ + "img/32_10.c2203a5e.png";